import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import "../clap/ClapNoticeInformation.scss";
import "../../../layout/styles/inline-cgos.css";
import './DemandeAncv.scss';
import { Accordion, AccordionTab } from "primereact/accordion";

import { useDispatch, useSelector } from "react-redux";
import { AncvNoticeInformation } from "./AncvNoticeInformation";
import { FormulaireAncv } from "./FormulaireAncv";
import { getUsagerInfo } from "../../../store/actions/usager";
import {setFiche, setFullActionSociale} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { ClapService } from "../../../service/ClapService";
import { AgentService } from "../../../service/AgentService";
import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../clap/DemandeClap.scss";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RadioButton } from 'primereact/radiobutton';
import { Skeleton } from "primereact/skeleton";
import { Toast } from "primereact/toast";
import { FileService } from "../../../service/FileService";
import { ExerciceService } from "../../../service/ExerciceService";
import { RibService } from "../../../service/RibService";
import { FieldBuilder } from "../fields/FieldBuilder";
import Slider from "@material-ui/core/Slider";
import LoaderDots from '../fields/LoaderDots';



export const DemandeAncv = () => {

  const createMode = "create";
  const editMode = "edit";

  const { mode } = useParams();

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);

  const [editFormData, setEditFormData] = useState(null);
  const [currentActionSociale, setCurrentActionSociale] = useState({});

  const [disabledForm, disableForm] = useState(true);
  const [showLoading, setShowLoading] = useState(null);
  const [hiddenNoticeButton, hideNoticeButton] = useState(editMode === mode ? true : false);
  const [activeIndex, setActiveIndex] = useState([0]);
  const [hideAccordionCompleter, setHideAccordionCompleter] = useState(editMode === mode ? false : true);

  const [displayBasic, setDisplayBasic] = useState(false);
  const [displayError, setDisplayError] = useState([]);
  const [ibanMembre, setIbanMembre] = useState(null);

  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();
  const chequeCultureService = new ChequeCultureService();
  const ribService = new RibService();

  const linkService = new LinkProviderService();

  const dispatch = useDispatch();
  const history = useHistory();
  const [dataReady, setDataReady] = useState(false);

  const errors = {
      dod: 1,
      statut: 2,
      qf: 2,
      iban: 3,
      pac: 4,
      exercice:5,
      droits:6,
      siDossierValide:7,
      ibanEntranger:8,
      ibanNomtitulaire:9,
      siContentieux:10
    };

  const [qfWarning, setQfWarning] = useState(false);

    const checkErrors = (ficheAgent, errorList) => {
      if(ficheAgent.siNoFiche && !displayError.includes(errors.siContentieux) ){
          errorList.push(errors.exercice);
      }else if(!ficheAgent.siDodEncours) {

          if((actionSociale.exercice > ficheAgent.exerciceDod) && !displayError.includes(errors.exercice)) { errorList.push(errors.exercice); }
          if((!ficheAgent.droits.prestationSansCr ||
                      ( ['1','2'].includes(user.codePosition) && !['1','3','6','2','7'].includes(user.codeSituationAdministrative)) ||
                      ( ['3','4','5'].includes(user.codePosition) && (!['1','2','3'].includes(user.codeSituationAdministrative))) )  && !displayError.includes(errors.droits)) { errorList.push(errors.droits) }
          if(ficheAgent?.statutDod) {
            if(ficheAgent.statutDod !== '3' && !displayError.includes(errors.statut)) { errorList.push(errors.statut) }
            else if((ficheAgent.quotientFamilial == null) && !displayError.includes(errors.qf)) { setQfWarning(true); }
            else if(!ficheAgent.droits.prestationSansCr && !displayError.includes(errors.droits)) { errorList.push(errors.droits) }
          } else if(!displayError.includes(errors.dod)) {
              errorList.push(errors.dod);
          }
          if(!ficheAgent.siDossierValide && !displayError.includes(errors.siDossierValide)){
              errorList.push(errors.siDossierValide);
          }
          if(((ficheAgent?.codeContentieux && ficheAgent.codeContentieux === "3") || ficheAgent?.siOuvertPourMaladie)&& !displayError.includes(errors.siContentieux)){
              errorList.push(errors.siContentieux);
          }
      }else{
        if(((ficheAgent?.codeContentieux && ficheAgent.codeContentieux === "3") || ficheAgent?.siOuvertPourMaladie)&& !displayError.includes(errors.siContentieux)){
          errorList.push(errors.siContentieux);
      }
    }
        return errorList;
    };

  const getIbanMembre = async (ficheAgent) => {
      const { data } = await clapService.getIbanMembre(user.numCgos);
      setIbanMembre(data.numIBan);
      let errorList = [];
        //if(!ficheAgent.siDodEncours){
           if(!data.numIBan && !displayError.includes(errors.iban)){
               errorList.push(errors.iban);
           }
            if(data.numIBan ){
                if(!ribService.IsIbanCountryCodeValid(data.numIBan) && !displayError.includes(errors.ibanEntranger)) errorList.push(errors.ibanEntranger);
             }
            if(data.nomTitulaire){
                if(!ribService.IsIbanTitulaireNomValid(data.nomTitulaire,ficheAgent) && !displayError.includes(errors.ibanNomtitulaire)) errorList.push(errors.ibanNomtitulaire);
            }
        //}
      errorList = checkErrors(ficheAgent, errorList);
      setDisplayError(errorList);
  };



  if (createMode === mode && (!actionSociale || !actionSociale.cas || !actionSociale.exercice || actionSociale.listActionsSociale.length === 0)) {
    history.push("/choixPeriodeAncv/"+actionSociale.cas);
  }

  useEffect(() => {
    if (createMode === mode) {
      fetchDataForCreation();
    } else if (editMode === mode) {
       fetchDataForEdition();
    } else {
      window.location.assign(
        linkService.getRetourEaLoginAgent()
      );
    }

    initActiveIndex();
  }, []);

  useEffect(() => {
    if(createMode === mode) disabledForm ? setActiveIndex([0]) : setActiveIndex([1]);
    if(editMode === mode) setActiveIndex([1]);
  }, [disabledForm,dataReady, mode]);

  const fetchDataForCreation = () => {
    getFicheAgent();
    getCurrentActionSociale();
    setDataReady(true);
  };

  const fetchDataForEdition = () => {
     const as = {
           cas: "",
           exercice: "",
           fiche: "",
           optJustificatif: "",
           iban: "",
           maxVal: 0,
           enfants: [],
           listActionsSociale: [],
         };
     chequeCultureService.getEditDto().then((form) => {
           setEditFormData(form.data);
           as.cas = form.data.codeActionSociale;
           as.exercice = form.data.exercice.toString();

           dispatch(getUsagerInfo()).then((user) => {
               if (user != null && user != undefined) {
                 const bareme = {
                   casCode: as.cas,
                   delegId: user.codeDelegation,
                   exercie: as.exercice,
                   siActif: 1,
                 };


                 actionSocialeService.getActionSocialeDematByCASAndDlg(as.cas, user.codeDelegation).then((asList) => {
                     Object.values(asList.data).map((item) => {
                       as.listActionsSociale.push(item);
                       if (item.codeActionSociale === as.cas && item.exercice === as.exercice) {
                         setCurrentActionSociale(item);
                       }
                     });

                    if((mode == editMode && asList.data.length == 0)){
                                        let defaultActionSocial={codeActionSociale: as.cas,codeLibelle: "CHÈQUES-VACANCES",
                                        dateDebut: as.exercice,dateFin: as.exercice,codeDelegation: user.codeDelegation ,exercice: as.exercice,defaultEditMode:true
                                        }
                                        as.listActionsSociale.push(defaultActionSocial);
                                        setCurrentActionSociale(defaultActionSocial);
                    }


                     agentService.getFicheAgent(user.numCgos, as.exercice).then((fiche) => {
                         as.fiche = fiche.data;
                         clapService.getIbanMembre(user.numCgos).then((resIban) => {
                             as.iban = resIban.data.numIBan;
                             dispatch(setFullActionSociale(as));
                             setDataReady(true);
                           });
                         });
                     });

                     

               } else {
                 window.location(
                   linkService.getRetourEaLoginAgent()
                 );
               }
             },
             (error) => {
               window.location(linkService.getRetourEaLoginAgent());
             }
           );
         });

  };

  
  const getFicheAgent = () => {
      setShowLoading(true);
     try {
        agentService.getFicheAgent(user.numCgos, actionSociale.exercice).then((res) => {
          dispatch(setFiche(res.data));
          setShowLoading(false);
          getIbanMembre(res.data);
        });
     } catch (error) {
           setShowLoading(false);
            if(!displayError.includes(errors.siContentieux) ){
                  displayError.push(errors.exercice);
            }
     }
  };


  const getCurrentActionSociale = () => {
    Object.values(actionSociale.listActionsSociale).forEach((as) => {
      if (as.codeActionSociale === actionSociale.cas && as.exercice === actionSociale.exercice) {
        setCurrentActionSociale(as);
        return;
      }
    });
  };


  const getDateFormat = (date) => {
    return new Date(date).toLocaleDateString("fr-FR", {});
  };

  const checkDateisValid = (date) => {
       return new Date(date) instanceof Date && !isNaN(new Date(date));
  };

  const initActiveIndex = () => {
    if(createMode === mode) setActiveIndex([0]);
    if(editMode === mode) setActiveIndex([1]);
  };

  const handleConfirm = (e) => {
    disableForm(e);
    hideNoticeButton(!e);
    setHideAccordionCompleter(false);
  };


  return (
    <div className="grid cld-width">
          <ChequeCultureLegacy />
          <div className="col-12 mx-auto">
            <div
              className="no_shadow_no_border card "
              style={{ display: !displayBasic ? "block" : "none"}}
            >
              <nav aria-label="breadcrumb" class="pt-3">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a
                      href={linkService.getRetourEaAccueilAgent()}
                      target="_self"
                    >
                      Espace Agent
                    </a>
                  </li>

                  <li class="breadcrumb-item">
                    <a
                      href={linkService.getRetourEaMembrePrestation()}
                      target="_self"
                    >
                      Prestations et Formulaires
                    </a>
                  </li>

                  <li aria-current="page" class="breadcrumb-item active">
                    Demande de prestation
                  </li>
                </ol>
              </nav>
              <p></p>
              {currentActionSociale && (
                <div style={{marginBottom: '2%'}}>
                  <h1 style={{ color: "#676767", fontWeight: 300 }}>
                    Prestation {(createMode === mode ) && currentActionSociale.exercice}
                  </h1>
                  <h1 style={{ color: "#676767", fontWeight: 100 }}>
                     CHÈQUES-VACANCES
                  </h1>
                  {(createMode === mode ) && checkDateisValid(currentActionSociale.dateFin) && !currentActionSociale?.defaultEditMode &&
                                <h4>
                                  <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif",}}>
                                    Demande de prestation possible jusqu'au {" "}
                                    {getDateFormat(currentActionSociale.dateFin)}
                                  </span>
                                </h4>}
                  {(createMode === mode ) && !checkDateisValid(currentActionSociale.dateFin) &&
                    <div className="alert alert-danger" style={{textAlign:"center"  }}>
                                  <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif",}}>
                                  Ce formulaire de demande de prestation n’est plus disponible</span>
                    </div>}
                    {(displayError.includes(errors.siContentieux) ) && (
                        <div class="astuce-box-error top-msg-resize">
                           <b>Vous ne pouvez pas accéder au formulaire de cette prestation pour le moment.</b>
                           <p>Adressez-vous à la délégation C.G.O.S de votre région pour en savoir plus. <a href={'https://www.cgos.info/'+user.codeDelegation+'/nous-contacter/'} target="_blank">Nous contacter</a>.</p>
                        </div>
                    )}
                    {actionSociale.fiche.siDodEncours && (!displayError.includes(errors.siContentieux) ) && (
                         <div class="astuce-box-warning top-msg-resize">
                            <b>Vos droits ne sont pas encore ouverts.</b>
                            <p>Vous pouvez quand même envoyer une demande dès maintenant. <b>Elle sera examinée après l’ouverture de vos droits</b>. Si des ajustements sont nécessaires, le C.G.O.S vous demandera de mettre à jour votre demande.</p>
                         </div>
                    )}
                    {(displayError.includes(errors.exercice) || displayError.includes(errors.droits) || displayError.includes(errors.dod) || displayError.includes(errors.siDossierValide) ) && (
                        <div class="astuce-box-error top-msg-resize">
                           <b>Vous ne pouvez pas accéder au formulaire de cette prestation pour le moment.</b><br/>
                           Vous devez dabord actualiser votre dossier depuis la rubrique Dossier C.G.O.S en ligne. Pour en savoir plus ou si vous pensez qu’il y a une erreur,  <a href={'https://www.cgos.info/'+user.codeDelegation+'/nous-contacter/'} target="_blank">adressez-vous à votre Contact C.G.O.S.</a>
                        </div>
                    )}
                    {qfWarning  && (
                        <div class="astuce-box-warning top-msg-resize">
                           <b>Vous n'avez pas communiqué vos revenus. La prestation du C.G.O.S sera minimale.</b><br/>
                           Conformément à votre choix, cette prestation sera calculée sans tenir compte de vos revenus. Si vous souhaitez transmettre votre avis d'imposition, allez à la rubrique  <a href={linkService.getRetourEaContacterNousChangeSituations()} target="_blank">Prévenir d’un changement de situation</a>.
                        </div>
                    )}
                    {displayError.includes(errors.ibanEntranger)  && (
                         <div class="astuce-box-error top-msg-resize">
                              <b>Ce nouveau formulaire de prestation n’est pas encore compatible avec les banques situées à l’étranger.</b><br/>
                               Merci d’utiliser le formulaire classique PDF pour envoyer une demande de Chèques-Vacances.
                         </div>
                    )}
                    {displayError.includes(errors.iban)  && (
                         <div class="astuce-box-error top-msg-resize">
                            <b>Vous ne pouvez pas accéder au formulaire de cette prestation pour le moment.</b><br/>
                             Vous devez d'abord fournir le relevé d'identité bancaire qui sera utilisé pour le versement des prestations. Transmettez ce document depuis la <a  href={linkService.getRetourEaPreferenceBancaires()} target="_blank">page Références bancaires.</a>
                         </div>
                    )}
                    {displayError.includes(errors.ibanNomtitulaire)  && (
                         <div class="astuce-box-error top-msg-resize">
                            <b>Vous ne pouvez pas accéder au formulaire de cette prestation pour le moment.</b><br/>
                            Vos coordonnées bancaires actuelles ne remplissent pas certaines des conditions requises (le nom et prénom du titulaire du compte doivent être identiques à ceux associés à votre numéro C.G.O.S).<br/>
                            Transmettez vos coordonnées bancaires à jour depuis la <a  href={linkService.getRetourEaPreferenceBancaires()} target="_blank">page Références bancaires.</a><br/>
                            S'il s'agit d'une erreur, contactez le C.G.O.S.
                         </div>
                    )}
                </div>
              )}
              {((actionSociale?.listActionsSociale?.length > 0 && actionSociale?.fiche) || (editMode === mode)) &&
                <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} role="tablist">
                   <AccordionTab headerClassName="cgos-h2" header="COMPRENDRE LA PRESTATION">
                    <AncvNoticeInformation mode={mode} hiddenNoticeButton={hiddenNoticeButton} onConfirm={(e) => handleConfirm(e)} displayErrors={displayError} />
                  </AccordionTab>

                  <AccordionTab headerClassName="cgos-h2" header={ createMode === mode ? "COMPLETER LA DEMANDE DE PRESTATION" : "COMPLETER VOTRE DEMANDE" } disabled={true} style={{display: hideAccordionCompleter ?  "none":"block" }}>
                  {dataReady && <FormulaireAncv mode={mode} oldForm={editFormData} />}
                  </AccordionTab> 
                </Accordion>
              }

                <Dialog closable={false} header="" visible={showLoading} modal>
                     <div className="loader">
                          <div className="loader-msg">Traitement en cours, merci de patienter</div>
                          <div className="form-row-separator-10"></div>
                          <LoaderDots />
                     </div>
                </Dialog>
            </div>
          </div>
        </div>
      );
};
